import React from 'react';
import { TextFieldGroup } from '~/admin/shared/forms/BasicForm';
import { useIntl } from 'react-intl';
import Grid from '~/shared/Grid';
import { blank, textLengthValidatorSync, validEmail, VALIDATION_TIMEOUT, type Validator } from '~/utils/forms';

// Salesforce Account.Partner_Rep__c is a single 255-char field holding "first last",
// so each name part is capped to leave room for the other plus the joining space.
const MAX_PARTNER_NAME_PART_LENGTH = 127;
// Salesforce Account.Partner_Rep_Email__c is a 80-char field.
const MAX_PARTNER_EMAIL_LENGTH = 80;

// Trim before validating so a value that would be valid once trimmed (matching how the
// backend trims before checking presence/length) doesn't show a spurious error while typing.
const validatePartnerNamePart: Validator = value => textLengthValidatorSync({ max: MAX_PARTNER_NAME_PART_LENGTH })((value ?? '').trim());

const validatePartnerEmail: Validator = (value, instance) => instance.debounce(
  () => {
    const trimmedValue = (value ?? '').trim();
    if (blank(trimmedValue)) return false;
    return validEmail(trimmedValue) || textLengthValidatorSync({ max: MAX_PARTNER_EMAIL_LENGTH })(trimmedValue);
  },
  VALIDATION_TIMEOUT,
);

// isRequiredTitleLabel interpolates title into a template string (TextField.jsx's textTitle
// logic), so title must stay a plain string here, not a <FormattedMessage> element — same as
// SyscoOpcoField.
const SyscoPartnerFields = () => {
  const intl = useIntl();

  return (
    <Grid container>
      <Grid item xs={12} sm={4}>
        <TextFieldGroup
          field="partnerFirstName"
          title={intl.formatMessage({ defaultMessage: 'First Name' })}
          validate={validatePartnerNamePart}
          isRequiredTitleLabel
          data-testid="sysco-partner-first-name-input"
          data-tour-id="sysco-partner-first-name-input"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextFieldGroup
          field="partnerLastName"
          title={intl.formatMessage({ defaultMessage: 'Last Name' })}
          validate={validatePartnerNamePart}
          isRequiredTitleLabel
          data-testid="sysco-partner-last-name-input"
          data-tour-id="sysco-partner-last-name-input"
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextFieldGroup
          field="partnerEmail"
          title={intl.formatMessage({ defaultMessage: 'Email' })}
          placeholder="name@example.com"
          type="email"
          validate={validatePartnerEmail}
          isRequiredTitleLabel
          data-testid="sysco-partner-email-input"
          data-tour-id="sysco-partner-email-input"
        />
      </Grid>
    </Grid>
  );
};

export default SyscoPartnerFields;
